import {Grid, Typography} from '@yandex-delivery/blocks'
import React from 'react'

import {DropDown} from '../dropdown/Dropdown'
import {DropdownList} from '../dropdown-list/DropdownList'
import {ControlPanelProps} from './ControlPanel.types'
import {desktopClasses} from './ControlPanel@desktop.classes'

export function ControlPanel({controlPanelData}: ControlPanelProps) {
  return (
    <Grid alignItems="center" container>
      {controlPanelData.map((item, index) => (
        <Grid key={index} className={desktopClasses.gap} item>
          <DropDown dropdownContent={<DropdownList list={item.list} />}>
            <Typography className={desktopClasses.label} color="invert" thickness="regular" variant="body2">
              {item.button.label}
            </Typography>
          </DropDown>
        </Grid>
      ))}
    </Grid>
  )
}
